function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6494 1.33325L11.5662 3.41647C10.1722 2.49284 8.27649 2.64446 7.04819 3.87276L5.69429 5.22666L6.45726 5.98963L5.98976 6.45714L5.22678 5.69417L3.87288 7.04807C2.64459 8.27636 2.49296 10.1721 3.41659 11.5661L1.33337 13.6493L2.35067 14.6666L4.43015 12.5834C5.82414 13.507 7.71986 13.3554 8.94815 12.1271L10.3058 10.7732L9.54282 10.0102L10.0103 9.5427L10.7733 10.3057L12.1272 8.94802C13.3555 7.71973 13.5071 5.82402 12.5835 4.43003L14.6667 2.35055L13.6494 1.33325ZM7.13422 6.66659L9.33337 8.86574L8.86587 9.33325L6.66671 7.13409L7.13422 6.66659Z"
});

var SvgIcoPlugin = function SvgIcoPlugin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "rgba(255,255,255,.5)",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoPlugin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-plugin.c2caf3f7.svg";
export { ForwardRef as ReactComponent };